import { render, staticRenderFns } from "./NewBuyModal.vue?vue&type=template&id=0609a1fd&"
import script from "./NewBuyModal.vue?vue&type=script&lang=js&"
export * from "./NewBuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports